const showHide = () => {
  const remotes = document.querySelectorAll('[data-toggle="show-hide"]');

  Array.from(remotes).forEach((remote) => {
    remote.addEventListener('click', (e) => {
      const element = e.currentTarget;
      const target = document.querySelector(element.dataset.target);

      element.classList.toggle('is-active');

      if (target) {
        target.classList.toggle('is-active');
      }
    });
  });
};

export default showHide;



// WEBPACK FOOTER //
// ./resources/assets/js/functions/showhide.js